export default {
    computed: {
        icons() {
            let icon_filepaths = [];
            for (let i = 1; i <= 35; i++) {
                icon_filepaths.push(
                    `https://pacific-screening.imgix.net/programs/program-icon-${i}.jpg?auto=enhance,compress,format&width=200&q=60`
                );
            }
            return icon_filepaths;
        },

        randomIcon() {
            return this.icons[Math.floor(Math.random() * this.icons.length)];
        },
    },
};
